export const backgrounds = [
  [
    "#e6002e",
    "#ff1b2a",
    "#ff5c05",
    "#ff9d00",
    "#ffb000",
    "#ff9d00",
    "#ff5c05",
    "#ff1b2a",
    "#e6002e",
  ],
  [
    "#e6002e",
    "#ff1b2a",
    "#ff5c05",
    "#ff7000",
    "#ff9d00",
    "#ff9d00",
    "#ff7000",
    "#ff5c05",
    "#ff1b2a",
    "#e6002e",
  ],
  [
    "#e6002e",
    "#ff1b2a",
    "#ff5c05",
    "#ff7000",
    "#ff9d00",
    "#ffb000",
    "#ff9d00",
    "#ff7000",
    "#ff5c05",
    "#ff1b2a",
    "#e6002e",
  ],
  [
    "#e6002e",
    "#ff1b2a",
    "#ff5c05",
    "#ff7000",
    "#ff9d00",
    "#ffb000",
    "#ffb000",
    "#ff9d00",
    "#ff5c05",
    "#ff7000",
    "#ff1b2a",
    "#e6002e",
  ],
  [
    "#e6002e",
    "#ff1b2a",
    "#ff5c05",
    "#ff7000",
    "#ff8600",
    "#ff9d00",
    "#ffb000",
    "#ff9d00",
    "#ff8600",
    "#ff7000",
    "#ff5c05",
    "#ff1b2a",
    "#e6002e",
  ],
  [
    "#ff0033",
    "#ff002f",
    "#ff1b2a",
    "#ff431d",
    "#ff5c05",
    "#ff7000",
    "#ffb000",
    "#ffb000",
    "#ff7000",
    "#ff5c05",
    "#ff431d",
    "#ff1b2a",
    "#ff002f",
    "#ff0033",
  ],
  [
    "#ff0033",
    "#ff002f",
    "#ff1b2a",
    "#ff431d",
    "#ff5c05",
    "#ff7000",
    "#ff9d00",
    "#ffb000",
    "#ff9d00",
    "#ff7000",
    "#ff5c05",
    "#ff431d",
    "#ff1b2a",
    "#ff0033",
    "#ff002f",
  ],
  [
    "#ff0033",
    "#ff002f",
    "#ff1b2a",
    "#ff431d",
    "#ff5c05",
    "#ff7000",
    "#ff8600",
    "#ff9d00",
    "#ff9d00",
    "#ff8600",
    "#ff7000",
    "#ff5c05",
    "#ff431d",
    "#ff1b2a",
    "#ff002f",
    "#ff0033",
  ],
  [
    "#eb3246",
    "#ec4045",
    "#ed4045",
    "#ee6243",
    "#f07242",
    "#f18042",
    "#f29240",
    "#f3a43f",
    "#f4b13e",
    "#f3a43f",
    "#f29240",
    "#f18042",
    "#f07242",
    "#ee6243",
    "#ed4045",
    "#ec4045",
    "#eb3246",
  ],
];
